import { render, staticRenderFns } from "./JobsSection.vue?vue&type=template&id=235901a9&scoped=true"
import script from "./JobsSection.vue?vue&type=script&lang=js"
export * from "./JobsSection.vue?vue&type=script&lang=js"
import style0 from "./JobsSection.vue?vue&type=style&index=0&id=235901a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235901a9",
  null
  
)

export default component.exports